<script setup lang="ts">
import AgilaInfoBlock from "frontend-component-templates/src/components/agilaInfoBlock.vue";
import AgilaButton from "frontend-component-templates/src/components/agilaButton.vue";
import { defineEmits, defineProps, withDefaults } from "vue";
import { Product } from "../../classes/product";

interface Props {
  product?: Product;
  selectedDate?: Date;
  liability: boolean;
  defaultProduct: number;
  forceMobile?: boolean;
  index?: number;
}

const props = withDefaults(defineProps<Props>(), {
  product: undefined,
  selectedDate: undefined,
  liability: false,
  defaultProduct: undefined,
  forceMobile: false,
  index: 0,
});

const emit = defineEmits<{
  (e: "selectProduct", product: Product): void;
}>();
</script>

<template>
  <div
    class="table-head-column-con"
    :class="{
      noBorderRadius: defaultProduct === props.index + 1,
    }"
  >
    <div
      class="table-head-column__name"
      :class="{ mobile: !props.forceMobile }"
    >
      {{ props.product.getDisplayNameMobile() }}
    </div>
    <div class="table-head-column__name desktop" v-if="!props.forceMobile">
      {{ props.product.getDisplayNameDesktop() }}
    </div>
    <div
      class="table-head-column__price"
      :class="{ 'display-none': !props.product.price }"
    >
      <template v-if="props.product.price">
        <span v-if="!props.product.final" class="table-head-column__price--ab"
          >ab</span
        >
        <div v-if="props.liability">
          <template v-if="props.product.id === 6">3,30 € </template>
          <template v-if="props.product.id === 7">4,40 € </template>
        </div>
        <template v-else>
          {{ " " + props.product.getDisplayPrice() + " " }}
        </template>
        <span>mtl.</span>
        <template v-if="props.liability">
          <span v-if="props.product.id === 6"> statt 6,60 € </span>
          <span v-if="props.product.id === 7"> statt 8,80 € </span>
        </template>
      </template>
    </div>
    <agila-button
      v-if="props.product.price"
      @click="emit('selectProduct')"
      :class="'lre_' + props.product.id"
      ariaLabel="Tarif wählen"
      :yellow="true"
    >
      <span :class="{ 'select-btn-mobile': !props.forceMobile }">{{
        props.liability ? "Hinzufügen" : "Wählen"
      }}</span>
      <span class="select-btn-desktop" v-if="!props.forceMobile">{{
        props.liability ? "Hinzufügen" : "Tarif wählen"
      }}</span>
    </agila-button>
    <agila-info-block v-else :show-icon="false" :small="true">{{
      props.product.getErrorMessage(props.selectedDate)
    }}</agila-info-block>
  </div>
</template>

<style scoped lang="scss"></style>
